export enum PriceBookViewByFields {
  CUSTOMER = "CUSTOMER",
  CUSTOMER_LOCATION = "CUSTOMER_LOCATION",
  TERMS = "TERMS",
}
